import React from 'react'
import { Route, RouteProps, useHistory } from 'react-router-dom'

import { AgencySettings_EnabledFeaturesEnum } from 'src/api/gen'
import { Permission, userHasAtLeastOnePermission, userHasPermissions } from 'src/commons/permissions'

import { useCheckEnabledFeature } from './AgencySettings'

interface IOwnProps {
  redirectTo?: string
  requiredFeatures?: AgencySettings_EnabledFeaturesEnum[]
  requiredPermissions?: Permission[]
  requiredPermissionsUnion?: Permission[]
}

export default function (props: IOwnProps & RouteProps) {
  const {
    redirectTo = '/',
    requiredFeatures = [],
    requiredPermissions = [],
    requiredPermissionsUnion = [],
    ...routeProps
  } = props

  const isFeatureEnabled = useCheckEnabledFeature()
  const history = useHistory()

  const areFeaturesEnabled = requiredFeatures.every(isFeatureEnabled)
  const shouldRedirect =
    !areFeaturesEnabled ||
    !userHasPermissions(requiredPermissions) ||
    !userHasAtLeastOnePermission(requiredPermissionsUnion)

  if (shouldRedirect) {
    history.replace(redirectTo)
    return null
  }

  return <Route {...routeProps} />
}
